import React, { Component } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { getNewsFeed } from '../../utils/api/services/news';
import NewsSliderItem from './NewsSliderItem';
import Preloader from '../../components/Preloader/Preloader';
import paths from '../../paths';

export default class NewsSlider extends Component {
  constructor(props) {
    super(props);

    this.slidesCount = 4;
    this.sliderSettings = {
      autoplay: true,
      autoplaySpeed: 3000,
      adaptiveHeight: true,
    };

    this.state = {
      isLoading: false,
      news: [],
    };
  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData = () => {
    this.setState({ isLoading: true });
    getNewsFeed(0, this.slidesCount)
      .then((result) => {
        this.setState({
          news: result.data,
        });
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  render() {
    const { news, isLoading } = this.state;

    if (!news.length) {
      return (<React.Fragment />);
    }

    return (
      <div className="section bg-dragonfly2">
        {
          isLoading ? (
            <Preloader />
          ) : (
            <Slider {...this.sliderSettings} className="news-slider">
              {news.map(item => (
                <NewsSliderItem
                  key={item.id}
                  title={item.title}
                  announce={item.announce}
                  createdDate={item.createdDate}
                  to={`${paths.advocates.news}/${item.alias}`}
                />
              ))}
            </Slider>)

        }

        <div className="section-more">
          <Link to={paths.advocates.news} className="btn -more">
            Читать все новости
          </Link>
        </div>
      </div>
    );
  }
}
